import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { isAnyOfficialComponent } from "@next-tsx/parser";
import { convertEvents } from "./convertEvents.js";
import convertList from "./convertList.js";
import convertTable from "./convertTable.js";
import convertDescriptions from "./convertDescriptions.js";
import convertDashboard from "./convertDashboard.js";
import convertButton from "./convertButton.js";
import convertForm from "./convertForm.js";
import convertFormItem from "./convertFormItem.js";
import convertModal from "./convertModal.js";
import convertToolbar from "./convertToolbar.js";
import convertText from "./convertText.js";
import convertCard from "./convertCard.js";
import convertForEach from "./convertForEach.js";
import convertIf from "./convertIf.js";
import convertOutput from "./convertOutput.js";
import convertLink from "./convertLink.js";
import convertTag from "./convertTag.js";
import convertAvatar from "./convertAvatar.js";
import convertAvatarGroup from "./convertAvatarGroup.js";
import convertCodeBlock from "./convertCodeBlock.js";
import { getAppTplName, getViewTplName } from "./modules/getTplName.js";
import { convertRoutes } from "./modules/convertRoutes.js";
import { convertLifeCycle } from "./convertLifeCycle.js";
var PORTAL_COMPONENTS = ["eo-modal", "eo-drawer"];
export function convertComponent(_x, _x2, _x3, _x4, _x5) {
  return _convertComponent.apply(this, arguments);
}
function _convertComponent() {
  _convertComponent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(component, mod, state, options, scope) {
    var _component$children;
    var brick, componentName, _refPart, _ref, type, importSource, name, refPart, imported, parts, tplName, _brick, _brick$properties, _brick$properties2, _brick$properties2$da, _t;
    return _regeneratorRuntime().wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          brick = null;
          if (!isAnyOfficialComponent(component)) {
            _context.next = 43;
            break;
          }
          componentName = component.reference ? component.reference.name : component.name;
          _t = componentName;
          _context.next = _t === "List" ? 1 : _t === "Table" ? 3 : _t === "Descriptions" ? 5 : _t === "Card" ? 7 : _t === "Dashboard" ? 9 : _t === "Button" ? 11 : _t === "Form" ? 13 : _t === "Toolbar" ? 15 : _t === "Modal" ? 17 : _t === "Plaintext" ? 19 : _t === "Link" ? 21 : _t === "Output" ? 23 : _t === "Tag" ? 25 : _t === "Avatar" ? 27 : _t === "AvatarGroup" ? 29 : _t === "CodeBlock" ? 31 : _t === "Search" ? 33 : _t === "Input" ? 33 : _t === "NumberInput" ? 33 : _t === "Textarea" ? 33 : _t === "Select" ? 33 : _t === "Radio" ? 33 : _t === "Checkbox" ? 33 : _t === "Switch" ? 33 : _t === "DatePicker" ? 33 : _t === "TimePicker" ? 33 : _t === "ForEach" ? 35 : _t === "If" ? 37 : _t === "Routes" ? 39 : _t === "Route" ? 40 : 41;
          break;
        case 1:
          _context.next = 2;
          return convertList(component);
        case 2:
          brick = _context.sent;
          return _context.abrupt("continue", 42);
        case 3:
          _context.next = 4;
          return convertTable(component, mod, state, options, scope);
        case 4:
          brick = _context.sent;
          return _context.abrupt("continue", 42);
        case 5:
          _context.next = 6;
          return convertDescriptions(component, mod, state, options, scope);
        case 6:
          brick = _context.sent;
          return _context.abrupt("continue", 42);
        case 7:
          _context.next = 8;
          return convertCard(component);
        case 8:
          brick = _context.sent;
          return _context.abrupt("continue", 42);
        case 9:
          _context.next = 10;
          return convertDashboard(component, mod, state, options);
        case 10:
          brick = _context.sent;
          return _context.abrupt("continue", 42);
        case 11:
          _context.next = 12;
          return convertButton(component);
        case 12:
          brick = _context.sent;
          return _context.abrupt("continue", 42);
        case 13:
          _context.next = 14;
          return convertForm(component);
        case 14:
          brick = _context.sent;
          return _context.abrupt("continue", 42);
        case 15:
          _context.next = 16;
          return convertToolbar(component);
        case 16:
          brick = _context.sent;
          return _context.abrupt("continue", 42);
        case 17:
          _context.next = 18;
          return convertModal(component);
        case 18:
          brick = _context.sent;
          return _context.abrupt("continue", 42);
        case 19:
          _context.next = 20;
          return convertText(component);
        case 20:
          brick = _context.sent;
          return _context.abrupt("continue", 42);
        case 21:
          _context.next = 22;
          return convertLink(component, mod, state);
        case 22:
          brick = _context.sent;
          return _context.abrupt("continue", 42);
        case 23:
          _context.next = 24;
          return convertOutput(component);
        case 24:
          brick = _context.sent;
          return _context.abrupt("continue", 42);
        case 25:
          _context.next = 26;
          return convertTag(component);
        case 26:
          brick = _context.sent;
          return _context.abrupt("continue", 42);
        case 27:
          _context.next = 28;
          return convertAvatar(component);
        case 28:
          brick = _context.sent;
          return _context.abrupt("continue", 42);
        case 29:
          _context.next = 30;
          return convertAvatarGroup(component);
        case 30:
          brick = _context.sent;
          return _context.abrupt("continue", 42);
        case 31:
          _context.next = 32;
          return convertCodeBlock(component);
        case 32:
          brick = _context.sent;
          return _context.abrupt("continue", 42);
        case 33:
          _context.next = 34;
          return convertFormItem(component, convertComponentName(component.name));
        case 34:
          brick = _context.sent;
          return _context.abrupt("continue", 42);
        case 35:
          _context.next = 36;
          return convertForEach(component);
        case 36:
          brick = _context.sent;
          return _context.abrupt("continue", 42);
        case 37:
          _context.next = 38;
          return convertIf(component);
        case 38:
          brick = _context.sent;
          return _context.abrupt("continue", 42);
        case 39:
          return _context.abrupt("return", convertRoutes(component.children, state, mod, options));
        case 40:
          // Route is handled in convertRoutes
          // eslint-disable-next-line no-console
          console.error("<Route> should be a child of <Routes>.");
          return _context.abrupt("continue", 42);
        case 41:
          // Allow any bricks in app mode or when allowAnyBricks is true
          if ((state.app.appType === "app" || options.allowAnyBricks) && component.name.toLowerCase() === component.name) {
            brick = {
              brick: component.name.replaceAll("_", ".").replaceAll("--", "."),
              properties: component.properties
            };
          } else {
            // eslint-disable-next-line no-console
            console.error("Unknown component:", component.name);
          }
        case 42:
          _context.next = 44;
          break;
        case 43:
          _ref = component.reference, type = _ref.type, importSource = _ref.importSource, name = _ref.name;
          if (type === "imported") {
            imported = state.app.modules.get(importSource);
            refPart = name ? imported === null || imported === void 0 ? void 0 : imported.namedExports.get(name) : imported === null || imported === void 0 ? void 0 : imported.defaultExport;
          } else {
            parts = [].concat(_toConsumableArray(mod.internals), _toConsumableArray(mod.namedExports.values()));
            refPart = parts.find(function (part) {
              var _part$component$id;
              return part.type === "template" && ((_part$component$id = part.component.id) === null || _part$component$id === void 0 ? void 0 : _part$component$id.name) === name;
            });
          }
          if (((_refPart = refPart) === null || _refPart === void 0 ? void 0 : _refPart.type) === "template") {
            tplName = refPart.component.id.name;
            brick = {
              brick: state.app.appType === "app" ? getAppTplName(tplName) : getViewTplName(tplName, options.rootId),
              properties: component.properties
            };
          } else {
            // eslint-disable-next-line no-console
            console.error("Cannot find the component \"".concat(component.reference.name, "\"."));
          }
        case 44:
          if (brick) {
            _context.next = 45;
            break;
          }
          return _context.abrupt("return", []);
        case 45:
          if (component.ref) {
            if (scope === "template") {
              brick.ref = component.ref;
            } else {
              (_brick$properties = (_brick = brick).properties) !== null && _brick$properties !== void 0 ? _brick$properties : _brick.properties = {};
              (_brick$properties2$da = (_brick$properties2 = brick.properties).dataset) !== null && _brick$properties2$da !== void 0 ? _brick$properties2$da : _brick$properties2.dataset = {};
              brick.properties.dataset.ref = component.ref;
            }
          }
          if (component.slot) {
            brick.slot = component.slot;
          }
          brick.events = convertEvents(component, options);
          brick.lifeCycle = convertLifeCycle(component, options);
          if (!((_component$children = component.children) !== null && _component$children !== void 0 && _component$children.length)) {
            _context.next = 47;
            break;
          }
          _context.next = 46;
          return Promise.all(component.children.map(function (child) {
            return convertComponent(child, mod, state, options, scope);
          }));
        case 46:
          brick.children = _context.sent.flat();
          if ((component.name === "Card" || component.name === "Modal") && brick.children.length > 0) {
            brick.children = [{
              brick: "eo-content-layout",
              children: brick.children
            }];
          }
        case 47:
          if (component.portal || PORTAL_COMPONENTS.includes(brick.brick)) {
            brick.portal = true;
          }
          if (component.context) {
            brick.context = component.context;
          }
          return _context.abrupt("return", brick);
        case 48:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _convertComponent.apply(this, arguments);
}
function convertComponentName(name) {
  return name.includes("-") ? name : "eo".concat(name.replace(/([A-Z])/g, "-$1").toLowerCase());
}
//# sourceMappingURL=convertComponent.js.map